export function User() {
  return {
    id: "",
    username: "",
    password: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    roleName: "",
    warehouseName: "",
    warehouseId: "",
    warehouse: new Warehouse(),
    shopName: "",
    shopId: "",
    shop: new Shop(),
    status: ""
  };
}

export function Category() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE"
  };
}

export function Brand() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE"
  };
}

export function Unit() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE"
  };
}
export function Warehouse() {
  return {
    id: "",
    name: "",
    code: "",
    location: "",
    description: "",
    status: "ACTIVE"
  };
}

export function ProductGroup() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE"
  };
}

export function Product() {
  return {
    id: "",
    name: "",
    code: "",
    color: "",
    description: "",
    status: "ACTIVE",
    brandName: "",
    categoryName: "",
    productGroupName: "",
    brandId: "",
    categoryId: "",
    productGroupId: "",
    imageUrl: "",
    image: "",
    productUnits: [],
    brand: new Brand(),
    category: new Category(),
    productGroup: new ProductGroup(),
    deleteProductUnitIds: [],
    reorderQty: 0,
  };
}

export function ProductUnit() {
  return {
    id: "",
    factor: "",
    barcode: "",
    basicUnit: false,
    purchaseUnit: false,
    saleUnit: false,
    unitCost: 0.0,
    sellingPrice: 0.0,
    productId: "",
    unitName: "",
    factorUnitName: "",
    deleteProductUnitPriceIds: [],
    productUnitPriceList: [],
  };
}

export function ProductUnitPrice() {
  return {
    id: "",
    currencyId: "",
    buyingPrice: 0.0,
    unitCost: 0.0,
    sellingPrice: 0.0,
    wholesalePrice: 0.0
  };
}

export function StockTransfer() {
  return {
    id: "",
    issueDateInMilliSeconds: 0,
    issueNo: "",
    description: "",
    fromWarehouseName: "",
    toWarehouseName: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
    stockTransferItems: [],
    deleteStockTransferItemIds: []
  };
}

export function StockTransferItem() {
  return {
    id: "",
    qty: 0,
    remark: "",
    productCode: "",
    productName: "",
    stockTransferId: 0,
    productId: 0,
    productUnitId: 0,
    productUnits: [],
    factorUnitName: ""
  };
}

export function StockIn() {
  return {
    id: "",
    issueDateInMilliSeconds: 0,
    poNo: "",
    description: "",
    warehouse: new Warehouse(),
    warehouseName: "",
    status: "",
    stockInItems: [],
    deleteStockInItemIds: []
  };
}

export function StockInItem() {
  return {
    id: "",
    qty: 0,
    unitCost: 0,
    sellingPrice: 0,
    remark: "",
    productName: "",
    stockInId: 0,
    productId: 0,
    productUnitId: 0,
    productUnits: [],
    factorUnitName: "",

  };
}

export function Tax() {
  return {
    id: "",
    name: "",
    percentage: "",
    taxType: "",
    status: "",
    description: ""
  };
}
export function StockAdjustment() {
  return {
    id: "",
    issueDateInMilliSeconds: 0,
    warehouse: new Warehouse(),
    warehouseName: "",
    status: "",
    description: "",
    stockAdjustmentItems: [],
    deleteStockAdjustmentItemIds: []
  };
}

export function StockAdjustmentItem() {
  return {
    id: "",
    qty: 0,
    remark: "",
    productName: "",
    stockAdjustmentId: 0,
    productUnitId: 0,
    productUnits: [],
    factorUnitName: "",
  }
}

export function CounterCash() {
  return {
    id: "",
    counterName: "",
    cashType: "",
    amount: "",
    description: "",
    shopId: "",
    counterId: ""
  };
}

export function Shop() {
  return {
    id: "",
    name: "",
    code: "",
    city: "",
    township: "",
    address: "",
    phoneNo: "",
    warehouseId: "",
    isB2B: false,
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0
  };
}

export function Sale() {
  return {
    id: "",
    saleNo: "",
    netAmount: 0,
    taxAmount: 0,
    payChange: 0,
    totalAmount: 0,
    discountAmount: 0.0,
    username: "",
    shopId: 0,
    shopName: "",
    counterId: 0,
    counterName: "",
    payType: "",
    taxPercentage: 0,
    saleDate: "",
    saleItems: [],
    shiftAssignDetailId: 0,
    taxType: "ADD_ON",
    address: "",
    phoneNo: "",
    receivedAmount: 0,
    customerId: "",
    customerName: "",
    creditCashFlows: [],
    returnItems: [],
    notFocItems: [],
    focItems: [],
    salePersonId: 0,
    cardId: 0,
    cardNo: "",
    status: "CONFIRM",
    remark: "",
    currencyId: "",
    deleteSaleDetailIds: []
  };
}

export function SystemSerialize() {
  return {
    id: "",
    prefix: "",
    serializeNo: "",
    type: "",
    warehouseId: "",
    shopId: "",
    status: ""
  };
}

export function ShiftInfo() {
  return {
    id: "",
    name: "",
    startHour: "00:00",
    endHour: "23:59",
    shopId: "",
    status: ""
  };
}

export function ShiftAssign() {
  return {
    id: "",
    assignDateInMilliSeconds: 0,
    shiftAssignNo: "",
    shiftInfoId: "",
    shiftInfoName: "",
    assignDetailList: [],
    addAssignDetailList: [],
    deleteAssignDetailList: [],
    assignSalePersonList: []
  };
}

export function ShiftAssignDetail() {
  return {
    id: "",
    userId: "",
    username: "",
    counterId: "",
    counterName: "",
    status: true
  }
}

export function ShiftAssignSalePerson() {
  return {
    id: "",
    userId: "",
    username: "",
    status: true
  }
}

export function StockTake() {
  return {
    id: "",
    createdDateInMilliSeconds: 0,
    openingBalance: 0,
    stockInQty: 0,
    stockOutQty: 0,
    stockTransferInQty: 0,
    stockTransferOutQty: 0,
    stockAdjustmentDamageQty: 0,
    stockAdjustmentLossQty: 0,
    stockAdjustmentRefoundedQty: 0,
    closingBalance: 0,
    warehouseName: "",
    brandName: "",
    categoryName: "",
    productName: "",
    barcode: "",
    factor: 0,
    unitName: ""
  }

}

export function Currency() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE"
  };
}

export function CreditLevel() {
  return {
    id: "",
    name: "",
    periodDays: 0,
    description: ""
  }
}

export function CurrencyExchangeRate() {
  return {
    id: "",
    currencyId: "",
    currencyName: "",
    exchangeRate: ""
  };
}


export function Customer() {
  return {
    id: "",
    code: "",
    name: "",
    address: "",
    phoneNo: "",
    email: "",
    creditLevelId: "",
    customerType: "STANDARD"
  };
}

export function PurchaseOrder() {
  return {
    id: "",
    issueDateInMilliSeconds: "",
    issueNo: "",
    description: "",
    status: "",
    supplierId: "",
    companyName: "",
    currencyId: "",
    warehouseId: "",
    warehouseName: "",
    purchaseOrderItems: [],
    deletePurchaseOrderItemIds: []
  };
}

export function PurchaseOrderItem() {
  return {
    id: "",
    qty: 0,
    unitCost: 0,
    sellingPrice: 0,
    remark: "",
    purchaseOrderId: "",
    productId: "",
    productCode: "",
    productName: "",
    productUnitId: "",
    factorUnitName: "",
    productUnits: []
  }
}
export function Supplier() {
  return {
    id: "",
    companyName: "",
    address: "",
    phone: "",
    email: "",
    contactPerson: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
    productList: [],
    currencyList: [],
    deleteSupplierProductIds: [],
    deleteSupplierCurrencyIds: []
  };
}

export function SupplierProduct() {
  return {
    id: "",
    productId: "",
    productCode: "",
    productName: "",
    statusFlag: true
  };
}

export function SupplierCurrency() {
  return {
    id: "",
    currencyId: "",
    currencyCode: "",
    statusFlag: true
  };
}

export function PriceModel() {
  return {
    id: "",
    name: "",
    description: "",
    status: "",
    priceModelDetailList: [],
    deletePriceModelDetailIds: []
  }
}

export function PriceModelDetail() {
  return {
    id: "",
    sellingPrice: 0,
    priceModelId: "",
    productId: "",
    productName: "",
    factorUnitName: "",
    unitCost: 0,
    unitPrice: 0,
    productUnits: []
  }
}

export function WholeSaleHeader() {
  return {
    id: "",
    issueDateInMilliSeconds: "",
    issueNo: "",
    description: "",
    status: "DRAFT",
    deliveryInfo: "",
    netAmount: 0,
    taxAmount: 0,
    taxType: "ADD_ON",
    taxPercentage: 0,
    totalAmount: 0,
    discountAmount: 0,
    depositAmount: 0,
    customerId: "",
    shopId: "",
    customerName: "",
    customerType: "",
    isB2B: false,
    shopName: "",
    currencyId: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
    wholeSaleDetails: [],
    deleteWholeSaleDetailIds: []
  };
}

export function CreditCashFlow() {
  return {
    id: "",
    createdBy: "",
    paidDateInMilliSeconds: 0,
    paidAmount: "",
    description: "",
    saleId: "",
    wholeSaleId: ""
  }
}

export function CustomerCreditBalance() {
  return {
    createdDateInMilliSeconds: 0,
    customerCode: "",
    customerName: "",
    invoiceNo: "",
    shopName: "",
    periodDay: 0,
    Status: "",
    netAmount: 0,
    creditPaidAmount: 0,
    remainingAmount: 0,
    saleType: ""
  }
}

export function Discount() {
  return {
    id: "",
    name: "",
    percentage: "",
    description: "",
    status: "",
    discountType: ""
  }
}

export function Card() {
  return {
    id: "",
    cardNo: "",
    description: "",
    status: "ACTIVE",
    shopId: ""
  }
}

export function CashNote() {
  return {
    id: "",
    name: "",
    value: "",
    currencyCode: "",
    description: "",
    status: "ACTIVE"
  };
}

export function Denomination() {
  return {
    id: "",
    issueDateInMilliSeconds: 0,
    issueNo: "",
    shopId: "",
    type: "",
    currencyId: "",
    description: "",
    cashAmount: 0.0,
    kpayAmount: 0.0,
    bankTransferAmount: 0.0,
    status: "DRAFT",
    denominationDetailList: [],
    deleteDenominationDetailIds: []
  };
}

export function DenominationDetail() {
  return {
    id: "",
    cashNoteId: "",
    cashNoteValue: 0,
    qty: 0,
    cashAmount: 0.0,
    denominationId: "",
  };
}

export function Counter() {
  return {
    id: "",
    name: "",
    code: "",
    shopId: "",
    description: "",
    status: "ACTIVE",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0
  };
}
